<template>
  <div>
    <site-header></site-header>

    <main :class="$style.work" class="wrap">
      <div :class="$style.workItems">
        <article :class="$style.item" v-for="item in items">
          <router-link :to="`/work/${item.slug}`">
            <div :class="$style.thumbnail" v-if="getImage(item)">
              <img :src="getImage(item)">
            </div>
            <h2 :class="$style.title" v-html="item.title.rendered"></h2>
            <p :class="$style.description" v-html="item.acf.description"></p>
          </router-link>
        </article>
      </div>
    </main>

    <loader v-if="loading"></loader>
  </div>
</template>

<script>
  import axios from 'axios';
  import { get } from 'lodash';
  import SiteHeader from '../components/SiteHeader';
  import Loader from '../components/Loader';

  export default {
    name: 'home',

    components: {
      SiteHeader,
      Loader,
    },

    head: {
      title: {
        inner: 'Sound design and field recording',
      },
      meta: [{
        name: 'description',
        content: 'Freelance sound designer & field recordist based in London. Specialising in sound design for documentaries, FX recording, feature films, games, radio and installations',
      }],
    },

    data() {
      return {
        loading: true,
        items: [],
      };
    },

    methods: {
      getImage(item) {
        // No embeddable image so don't bother
        if (!get(item, '_embedded[\'wp:featuredmedia\'][0].media_details.sizes')) {
          return null;
        }

        // Cache the items and work out which will be the best to use
        const obj = item['_embedded']['wp:featuredmedia'][0].media_details.sizes; // eslint-disable-line

        if (typeof obj.medium_large !== 'undefined') {
          return obj.medium_large.source_url;
        }

        if (typeof obj.large !== 'undefined') {
          return obj.large.source_url;
        }

        if (typeof obj.full !== 'undefined') {
          return obj.full.source_url;
        }

        if (typeof obj.medium !== 'undefined') {
          return obj.medium.source_url;
        }

        return null;
      },
    },

    mounted() {
      axios.get('/api/work-items').then((response) => {
        if (response.data) {
          this.loading = false;
          this.items = response.data;
        }
      });
    },
  };
</script>

<style module>
  .work {
    padding-right: 1rem;
    padding-bottom: 2rem;
    padding-left: 1rem;
    max-width: 62.5em;

    @media (width >= 50em) {
      padding-right: 4rem;
      padding-left: 4rem;
    }
  }

  .workItems {
    display: flex;
    flex-wrap: wrap;
    margin-left: -1rem;

    @media (width >= 75em) {
      margin-left: -2rem;
    }
  }

  .item {
    width: 100%;
    margin-bottom: 2rem;
    margin-left: 1rem;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    & a {
      text-decoration: none;
    }

    @media (width >= 25em) {
      width: calc(50% - 1rem);

      &:nth-last-child(-n+2) {
        margin-bottom: 0;
      }
    }

    @media (width >= 50em) {
      width: calc(33.3333% - 1rem);
      margin-left: 1rem;

      &:nth-last-child(-n+3) {
        margin-bottom: 0;
      }
    }

    @media (width >= 75em) {
      width: calc(33.3333% - 2rem);
      margin-left: 2rem;
    }

    &:hover {
      & .thumbnail img {
        transform: scale(1.1);
      }
    }
  }

  .thumbnail {
    overflow: hidden;
    margin-bottom: 1rem;
    height: 10rem;

    & img {
      transition: transform 4s;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .title {
    margin-bottom: 0.25rem;
    font-size: 1.1rem;

    @nest a & {
      color: #000;
      text-decoration: none;
    }

    @nest .item:hover & {
      &, & a {
        color: #777;
      }
    }
  }

  .description {
    color: #999;
    font-size: 0.6rem;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
  }
</style>



// WEBPACK FOOTER //
// Home.vue?cea2eec0